import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { apiPublicRawPost } from "../DataService/apiClient";
import { Button } from "../Components/Button";
import FadeIn from "../Animations/FadeIn";
import { Icon } from "../Icons/Icon";
import { Turnstile } from "@marsidev/react-turnstile";
import "./SignIn.css";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!captchaToken) {
      toast.error("Bekräfta att du inte är en robot");
      return;
    }
    setIsLoading(true);

    try {
      const res = await apiPublicRawPost("/Auth/request-reset", { email, captchaToken });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setSent(true);
      toast.success("Vi har skickat en återställningslänk till din e-post.");
    } catch (err) {
      console.error(err);
      toast.error("Kunde inte skicka återställningslänken.");
    }

    setIsLoading(false);
  };

  return (
    <div className="signin-page">
      <FadeIn className="signin-card">
        <div className="signin-header">
          <div className="signin-icon">
            <Icon.LogIn width={36} height={36} />
          </div>
          <h1 className="signin-title">Återställ lösenord</h1>
          <p className="signin-subtitle">Ange din e-post så skickar vi en länk.</p>
        </div>

        <form onSubmit={handleSubmit} className="signin-form">
          <div className="signin-field">
            <label htmlFor="email">E-postadress</label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="namn@exempel.se"
            />
          </div>

          <div className="signin-turnstile-block">
            <label>Jag är inte en robot *</label>
            <Turnstile
              siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY!}
              onSuccess={(token) => setCaptchaToken(token)}
              onExpire={() => setCaptchaToken(null)}
              options={{ theme: 'light' }}
            />
          </div>

          <Button
            type="submit"
            className="signin-submit"
            disabled={isLoading || !captchaToken}
            text={isLoading ? "Skickar..." : "Skicka länk"}
          />

          {sent && <p className="signin-reset-note">Kolla din inkorg för länken.</p>}
        </form>
      </FadeIn>

      <ToastContainer />
    </div>
  );
};
